import React, { useState } from 'react'; 
import ConfirmDialog from './ConfirmDialog';

export const QCData = ({
  records,editMode,editableTitles,handleTitleChange,handleEditTitle,
  setEditMode,cycleMasterId,verifyTitle,verifyAllTitles,statusInfo
}) => { 
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(() => () => {});

  
  const handleEditClick = (uniqueKey, title) => {
    /*setConfirmMessage('Are you sure you want to edit this title?');
    setConfirmAction(() => () => {
      setEditMode((prev) => ({ ...prev, [uniqueKey]: true }));
    });
    setConfirmOpen(true);*/
    setEditMode((prev) => ({ ...prev, [uniqueKey]: true }));
  };
  
  const formatQcStatus = (status) => {
  if (!status || status === "none") return "Not verified";
   
  return status.charAt(0).toUpperCase() + status.slice(1);
};

  console.log("ks1="+statusInfo.ai_status);

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[1080px]">
        {/* Table Header */}
        <div className="flex items-center border-b border-gray-300 dark:border-gray-600 pb-2 text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase">
          <div className="w-50 text-left">Permutations</div>
          <div className="flex-1 w-full sm:w-1/2 pl-4">Titles</div>
           
          <div className="w-24 text-center">Status</div>
          <div className="w-32 text-center">Options</div>
            
        </div>

        {/* Table Rows */}
        {Array.isArray(records?.title) &&
          records.title.map((item, idx) => {
            const uniqueKey = `${records.productId}_${idx}`;
            const isEditing = editMode[uniqueKey];
 

            return (
              <div
                key={uniqueKey}
                className={`flex flex-wrap items-start text-sm border-t border-gray-200 py-2 pl-2`}
              >
                {/* Permutation */}
                <div className="w-50 text-left font-medium text-gray-800 dark:text-gray-200">
                  {item.key === 'start'
                    ? 'Baseline title'
                    : item.key.charAt(0).toUpperCase() + item.key.slice(1)}
                </div>

                {/* Title Field */}
                <div className="flex-1 w-full sm:w-1/2">
                  {!isEditing ? (
                   <span className="flex items-center space-x-1 break-words pl-2 text-gray-800 dark:text-gray-200" title={item.qc_status}>
  <span>{item.title}</span>
  {item.key !== 'start' ? 
    
  item.qc_status === 'verified' ? (
    // Verified tick
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={5}
      stroke="currentColor"
      className="w-4 h-4 text-green-500"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.5 12.75 6 6 9-13.5"
      />
    </svg>
  ) : (
    // Unverified X mark
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={5}
      stroke="currentColor"
      className="w-4 h-4 text-red-500"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  ) : ''}
</span>

                  ) : (
                    <input
                      type="text"
                      value={editableTitles[uniqueKey] || item.title}
                      onChange={(e) => handleTitleChange(e, uniqueKey)}
                      className="border px-2 py-1 rounded w-full mt-1"
                    />
                  )}
                </div>
 
                    {item.key !== 'start'  ? 
                     
                    <div className="w-24 text-center pr-2 text-gray-800 dark:text-gray-200">
                    {(formatQcStatus(item.qc_status) === 'Not verified') ?
                       <span className='text-xs rounded-sm bg-red-500 text-white px-1 py-1'>{formatQcStatus(item.qc_status)}</span>
                    :  <span className='text-xs rounded-sm bg-green-500 text-white px-1 py-1'>{formatQcStatus(item.qc_status)}</span> 
                    } 
                    </div> : ''}
                    {item.key !== 'start'  ? 
                    <div className="w-32 text-center mt-2 sm:mt-0 space-x-2">
                      
                      {(!isEditing ? (
                          <div>
                          <button disabled={statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running'}
                            className={` hover:underline ${statusInfo.cycle_status?.toLowerCase() === 'started'|| statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running' ? 'text-gray-300 cursor-not-allowed': 
                                      'text-blue-600 cursor-pointer'}`}
                            onClick={() => handleEditClick(uniqueKey, item.title)}
                             
                          >
                            Edit
                          </button>
                          {(formatQcStatus(item.qc_status) === 'Not verified') ?
                          <button
                              disabled={statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running'}
                              className={`pl-2 hover:underline ${statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running' ? 'text-gray-300 cursor-not-allowed': 
                                      'text-green-600 cursor-pointer'}`}
                              onClick={() =>
                                verifyTitle(
                                  cycleMasterId,             
                                  records.productId,         
                                  idx,
                                  uniqueKey,
                                  item.key,                  
                                  'verified',
                                                  
                                )
                              } 
                            >
                              Verify
                            </button>
                            : <button
                              disabled={statusInfo.cycle_status?.toLowerCase() === 'started'|| statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running'}
                              className={`pl-2 hover:underline ${statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running' ? 'text-gray-300 cursor-not-allowed': 
                                      'text-green-600 cursor-pointer'}`}
                              onClick={() =>
                                verifyTitle(
                                  cycleMasterId,             
                                  records.productId,         
                                  idx,
                                  uniqueKey,
                                  item.key,                  
                                  'not verified'                
                                )
                              }
                               
                            >
                              Unverify
                            </button>
                            }
                          </div>
                        ) : (
                          <div className="flex gap-2 justify-center">
                            <button disabled={
                                  !editableTitles[uniqueKey] ||
                                  editableTitles[uniqueKey].trim() === item.title.trim()
                                }
                              onClick={() =>
                                handleEditTitle(
                                  cycleMasterId,            // test_cycle_id
                                  records.productId,        // product_id
                                  idx,                      // index
                                  uniqueKey,                // uniqueKey
                                  editableTitles[uniqueKey],// new title
                                  item.key,                 // key
                                  item.title                // old title
                                )
                              }
                              className={` 
    ${
      !editableTitles[uniqueKey] ||
      editableTitles[uniqueKey].trim() === item.title.trim()
        ? " cursor-not-allowed"
        : "text-green-600 cursor-pointer"
    }`}
                            >
                              Save
                            </button>
                            <button
                              onClick={() => {
                                setEditMode((prev) => ({ ...prev, [uniqueKey]: false }));
                              }}
                              className="text-red-500 hover:underline"
                            >
                              Cancel
                            </button>
                          </div>
                        ))}
                    </div>
                    : ''}
              </div>
            );
          })}
          
          <div className='text-right pr-5'>
            {records.qc_status === 'verified' ? 
              <button disabled={statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running' }
                className={`px-3 py-1 text-sm rounded-md text-white ${statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running' ? 'bg-gray-300 cursor-not-allowed': 
                  'bg-red-500 cursor-pointer'}`}
                onClick={() => verifyAllTitles(cycleMasterId, records.productId, 'not verified')}> Unverify All</button> : 
              <button disabled={statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running'} 
                  className={`px-3 py-1 text-sm rounded-md text-white ${statusInfo.cycle_status?.toLowerCase() === 'started' || statusInfo.ai_status?.toLowerCase() === 'waiting' || statusInfo.ai_status?.toLowerCase() === 'failed' || statusInfo.ai_status?.toLowerCase() === 'running'  ? 'bg-gray-300 cursor-not-allowed': 
                  'bg-green-500 cursor-pointer'}`}
                   onClick={() => verifyAllTitles(cycleMasterId,records.productId,'verified')}>Verify All</button>
            }
          </div>
      </div>

      {/* Confirm Dialog */}
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          confirmAction();
          setConfirmOpen(false);
        }}
        message={confirmMessage}
      />
    </div>
  );
};
